import Icon from '../components/Icon.vue'

Icon.register({
  'sd-card': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M320 0c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64h-256c-35.3 0-64-28.7-64-64v-320l128-128h192zM160 160v-96h-48v96h48zM240 160v-96h-48v96h48zM320 160v-96h-48v96h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sd-card.js
// module id = 1864
// module chunks = 0